// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../types';

type Props = {
  marginTop?: ?string,
  marginBottom?: ?string,
  color?: ?string,
  width?: ?string,
};

const Divider = styled<any, Theme, Props>('hr')`
  border-color: ${props => (props.color ? props.color : props.theme.divider.color)};
  border-width: 1px 0 0;
  border-style: solid;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : props.theme.divider.marginBottom)};
  margin-top: ${props => (props.marginTop ? props.marginTop : props.theme.divider.marginTop)};
  ${props => props.width && css`
    width: props.width;
  `}
`;

export default Divider;
